/* @flow weak */

'use strict';

const React = require('react');
const ControlMixin = require('../../mixins/ControlMixin.jsx');

const _ = require('lodash');
const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const DropdownSelect = React.createClass({
  mixins: [ControlMixin],
  selectStyle: {},

  generateOptions() {
    return _.map(this.props.parts, part => {
      if (part.id == this.state.answer) {
        this.selectFont(part);
      }

      return (
        <option
          className='uc-c uc-c-dropdown-option'
          value={part.id}
          key={part.id}>
          {this.displayPartName(part)} {this.displayPrice(part)}
        </option>
      );
    });
  },

  selectFont(chosenPart) {
    if (_.get(this.props.question, 'metadata.control.Choose.ShowFont') || _.get(this.props.question, 'name') == 'Font') {
      if  (chosenPart && _.get(chosenPart, 'metadata.FontFamily') != null) {
        this.selectStyle = {'font-family': _.get(chosenPart, 'metadata.FontFamily')};
      } else {
        this.selectStyle = {};
      }
    }
  },

  handleDropdownChange(e) {
    var chosenPart = _.find(this.props.parts, { id: e.target.value });
    this.selectFont(chosenPart);
    this.handleChange(e);
  },

  render() {
    let firstOptionText = _.get(this.props.question, 'metadata.control.Choose.FirstOptionCustomText') || Config.features.chooseDropdownText[ln] || Config.features.chooseDropdownText['en_US'];
    let questionName = _.get(this.props.question, `metadata.lang.${ln}.DisplayName`) || _.get(this.props.question, 'name');

    return (
      <div className='uc-control uc-dropdown'>
          <select
            aria-label={questionName}
            name='uc-dropdown-select'
            value={this.state.answer}
            onChange={this.handleDropdownChange}
            tabIndex={this.props.tabIndex}
            disabled={this.state.locked}
            style={this.selectStyle}>
            <option value="">{firstOptionText}</option>
            {this.generateOptions()}
          </select>
      </div>
    );
  }
});

module.exports = DropdownSelect;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/DropdownSelect.jsx